import React from 'react'

import SidebarGriModule from 'gatsby-theme-kn/src/components/modules/SidebarGriModule'
import SidebarNewsModule from 'gatsby-theme-kn/src/components/modules/SidebarNewsModule'
import SidebarDownloadsModule from 'gatsby-theme-kn/src/components/modules/SidebarDownloadsModule'
import SidebarLinksModule from 'gatsby-theme-kn/src/components/modules/SidebarLinksModule'
import SidebarArticlesModule from 'gatsby-theme-kn/src/components/modules/SidebarArticlesModule'

const SidebarModule = ({ gri_numbers, news_relations, downloads, links, articles }) => {
  return (
    <div className="sidebar">
      {gri_numbers?.length > 0 && <SidebarGriModule gri_numbers={gri_numbers} />}
      {news_relations?.length > 0 && <SidebarNewsModule news={news_relations} />}
      {downloads?.length > 0 && <SidebarDownloadsModule downloads={downloads} />}
      {links?.length > 0 && <SidebarLinksModule links={links} />}
      {articles?.length > 0 && <SidebarArticlesModule articles={articles} />}
    </div>
  )
}

export default SidebarModule
